export default function formatDataLabel(val) {
  let isPercentageData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const num = Number(val);
  if (isPercentageData) {
    return num.toFixed(1) + '%';
  }
  const thousands = num / 1000;
  const formatted = thousands.toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
  return formatted + 'K';
}